import { useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationCapitalCard } from "web_myplann/Inspiration/Components/InspirationCapitalCard";
import { useInspirationMoney } from "web_myplann/Inspiration/Hooks/useInspirationMoney";

const R = Resources.Inspiration.Retirement;

type Props = {
	expenses: number;
	mortgage: number;
	mortgageEndYear: number;
	savings: number;
	remaining: number;
};

export const RetirementExampleBreakdown: FC<Props> = ({
	expenses,
	mortgage,
	mortgageEndYear,
	savings,
	remaining,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const money = useInspirationMoney();

	return (
		<InspirationCapitalCard
			rows={[
				{ label: t(R.exampleTodayLabel), value: money(expenses) },
				{
					label: t(R.exampleMortgageLabel, { year: mortgageEndYear }),
					value: `− ${money(mortgage)}`,
					valueColor: theme.palette.green.main,
				},
				{
					label: t(R.exampleSavingsLabel),
					value: `− ${money(savings)}`,
					valueColor: theme.palette.green.main,
				},
			]}
			remaining={{
				label: t(R.exampleRemainingLabel),
				value: money(remaining),
				suffix: t(R.perMonth),
			}}
		/>
	);
};
